import { Station } from '@models/Station'
import { HistoricStationValueDTO } from '@models/api/station/HistoricStationValueDTO'

export class HistoricStationValue {
  constructor(
    public stationID: Station['id'],
    public value: number
  ) {}

  static fromDTO(dto: HistoricStationValueDTO): HistoricStationValue {
    return new HistoricStationValue(Number(dto.ID_STATION), dto.VALUE)
  }
}
